import { Toaster } from "sonner";

export function Toast() {
  return (
    <Toaster
      position="bottom-center"
      toastOptions={{
        className:
          "bg-brand-50 text-brand-950 border border-brand-800 shadow-lg",
        duration: 5000,
      }}
    />
  );
}
